import React from "react";
import Notice from './Notice';

const NoticeApp = () =>{
    return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Notices</h5>
          </div>
        </div>
        <Notice />
      </div>
    </div >
  );
};

export default NoticeApp;
